module.exports = __webpack_public_path__ + "static/blog-img4-99530865df2d2e75c5706b9db8d8a8fb.jpg";